import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import PageBanner from "components/PageBanner";

import InvoicesTable from "pages/Invoices/Table";

import HomeBannerImg from "assets/images/home-banner-img.png";
import { ReactComponent as ArrowRightIcon } from "assets/images/arrow-right-icon.svg";

import { routes } from "routes/routes";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { getLatestIbanInvoices } from "store/features/ibanInvoiceSlice";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

const HomeMain: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isInvoicesLoading, setIsInvoicesLoading] = useState(false);

  const globalLoading = useAppSelector((state) => state.loading.isLoading);
  const invoices = useAppSelector(
    (state) => state.ibanInvoice.latestIbanInvoices,
  );

  useEffect(() => {
    // Fetch latest invoices on tab click
    setIsInvoicesLoading(true);
    dispatch(getLatestIbanInvoices())
      .unwrap()
      .finally(() => {
        setIsInvoicesLoading(false);
      });
  }, [dispatch]);

  const onCreateIbanInvoice = () => {
    analytics().sendEvent(AnalyticsEvents.home_create_invoice);
    navigate(routes.createInvoice, { state: { from: routes.home } });
  };

  const onGoToInvoices = () => {
    analytics().sendEvent(AnalyticsEvents.home_all_invoices);
    navigate(routes.invoices);
  };

  return (
    <>
      <Typography data-testid="home-heading" sx={{ mb: 0.5 }} variant="h3">
        Вітаємо в IBAN oplata!
      </Typography>
      <Typography sx={{ mb: 3 }} variant="body1" color="grey700">
        Простий та зручний сервіс для створення платіжних посилань
      </Typography>

      <PageBanner
        title="Нове посилання"
        subtitle="IBAN oplata генерує посилання з реквізитами, сумою та призначенням — оплата стає швидшою та зручнішою"
        img={HomeBannerImg}
        actionButtonText="Створити посилання"
        onActionsButtonClick={onCreateIbanInvoice}
      />

      <Box sx={{ pt: 5, width: "100%" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          sx={{ mb: 3 }}
        >
          <Box>
            <Typography sx={{ mb: 0.5 }} variant="h3">
              Мої посилання
            </Typography>
            <Typography variant="body1" color="grey700">
              Нещодавно створені
            </Typography>
          </Box>
          {invoices && invoices.length > 0 && (
            <Link
              component="button"
              color="text.primary"
              underline="none"
              onClick={onGoToInvoices}
              sx={{ display: "flex", alignItems: "center" }}
            >
              Всі посилання <ArrowRightIcon style={{ marginLeft: 0.5 }} />
            </Link>
          )}
        </Box>
      </Box>
      <InvoicesTable
        loading={isInvoicesLoading || globalLoading}
        ibanInvoices={invoices}
      />
    </>
  );
};

export default HomeMain;
